import CustomerAPI from 'api/customer';
import Loader from 'components/loader';
import React from 'react';
import ReportOptions from './reportOptions';
import ReportSummary from './reportSummary';
import {FormattedMessage} from 'react-intl';
import ReportSummaryErrorHandler from '../../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';

class MissingInformation extends React.Component {
  state = {
    data: [],
    filters: {},
    loaded: true,
    showNoDataMessage: false,
    error: false,
  };

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  updateReportData = (store, systemType, accountStatus, missingInformation) => {
    let filters = {
      accountStatus: accountStatus,
      missingInformation: missingInformation,
      store: store,
      systemType: systemType,
    };

    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        data: [],
      });
    }

    (this.fetching = makeCancelable(CustomerAPI.getMissingInformation(store, systemType, accountStatus, missingInformation)))
    .then(res => {
      if(res && (res.Contacts > 0 || res.Emails > 0 || res.Phones > 0 || res.Addresses > 0)) {
        this.setState({
          data: res,
          filters: filters,
          showNoDataMessage: false,
          error: false,
        });
      } else {
        this.setState({showNoDataMessage: true, error: false});
      }
      this.setState({loaded: true, filters: filters});
    }).catch((e) => {
      console.log(e);
      if (e && e.canceled) {return;}
      this.setState({loaded: true, error: true});
    });
  };

  render() {
    return (
      <div className="report-container">
        <span>
          <FormattedMessage id="reports.missing.information.description" />
        </span>
        <ReportOptions updateReportData={this.updateReportData} branches={this.props.branches} />
        <Loader loaded={this.state.loaded}>
          <ReportSummaryErrorHandler error={this.state.error}>
            <ReportSummary data={this.state.data} filters={this.state.filters} showNoDataMessage={this.state.showNoDataMessage}/>
          </ReportSummaryErrorHandler>
        </Loader>

      </div>
    );
  }
}

export default MissingInformation;
